import { css } from 'styled-components';
import { theme } from 'styles/theme';

/** 공통 스크롤바: thumb 기본 5px → 호버(data-scrollbar-hover=1) 8px — HiGrid와 동일 */
export const SCROLLBAR_THIN_PX = 5;
export const SCROLLBAR_EXPANDED_PX = 8;
/** 스크롤바 근처로 인식하는 hit 영역(px) */
export const SCROLLBAR_HOVER_HIT_PX = 16;

/**
 * 트랙 폭은 항상 확장 크기(8px)로 예약하고, 기본 상태는 thumb에 투명 테두리를 줘
 * 5px로 「보이게」만 한다. 폭이 변하지 않으므로 호버 시 콘텐츠 영역(clientWidth)이
 * 줄어들지 않아 우측 정렬 버튼이 밀리지 않는다.
 */
const THUMB_INSET_PX = (SCROLLBAR_EXPANDED_PX - SCROLLBAR_THIN_PX) / 2;

/**
 * overflow 영역에 붙이는 스크롤바 스타일.
 * JS에서 data-scrollbar-hover=0|1 토글 필요 (@see useScrollbarHoverProps)
 */
export const hoverExpandScrollbarCss = css`
  /*
   * Chrome는 scrollbar-width가 있으면 ::-webkit-scrollbar 호버가 무시됨.
   * Firefox 등 WebKit 미지원 브라우저에만 standard 속성 적용.
   */
  @supports not selector(::-webkit-scrollbar) {
    /* 폭 변경 없이 색만 강조 — gutter 고정으로 레이아웃 흔들림 방지 */
    scrollbar-width: thin;
    scrollbar-gutter: stable;
    scrollbar-color: ${theme.colors.septenary} transparent;

    &[data-scrollbar-hover='1'] {
      scrollbar-color: ${theme.colors.octonary} transparent;
    }
  }

  &::-webkit-scrollbar {
    width: ${SCROLLBAR_EXPANDED_PX}px;
    height: ${SCROLLBAR_EXPANDED_PX}px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-corner {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${theme.colors.septenary};
    border-radius: 999px;
    /* 투명 테두리만큼 안쪽으로 그려져 실제 두께는 ${SCROLLBAR_THIN_PX}px로 보인다 */
    border: ${THUMB_INSET_PX}px solid transparent;
    background-clip: padding-box;
  }

  &[data-scrollbar-hover='1']::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-thumb:hover,
  &::-webkit-scrollbar-thumb:active {
    background-color: ${theme.colors.octonary};
    /* 트랙 폭은 그대로, thumb만 ${SCROLLBAR_EXPANDED_PX}px로 꽉 채움 */
    border-width: 0;
  }
`;
